import Vue from 'vue'
import Vuex from 'vuex'
import DictSvc from '@/services.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    langs: ['eng', 'ger', 'ita', 'hrv', 'pol'],
    list: [],
    lang: 'eng',
    total: 0,
    page: 0,
    per_page: 0
  },
  getters: {
    idx: (state) => (id) => {
      return state.list.findIndex(obi => obi.id == id)
    },
  },
  mutations: {
    UPDATE_LIST(state, pl) {
      if (state.langs.includes(pl.lang)) {
        state.lang = pl.lang
        state.total = pl.total
        state.page = pl.page || state.page
        state.per_page = pl.per_page || state.per_page
        state.list = pl.list
      }
    },
    UPDATE(state,pl) {
      state.list[state.getters.idx(pl.id)] = pl
    },
    DELETE(state, idx) {
      state.list.splice(idx,1)
    }
  },
  actions: {
    fetchList({commit}, pl) {
      DictSvc.getList(pl.lang, pl.per_page, pl.page)
        .then((myJSON) => {
            commit('UPDATE_LIST', {...pl, ...{'list': myJSON['dict'], 'total': myJSON['total']}})
        })
        .catch(() => {
        })
    },
  },
  modules: {
  }
})
